<template>
  <v-app>
    <div class="maincontainer">
      <div>
        <h2 class="mt-12 title">メールアドレス確認完了</h2>
      </div>
      <div class="mt-12">
        <p class="message">メールアドレスの確認が完了しました。</p>
      </div>
      <div>
        <v-btn
          class="mt-5"
          height="35"
          width="100"
          rounded="pill"
          to="/"
          color="rgb(237, 121, 149)"
        >
          <a class="login">トップへ</a>
        </v-btn>
      </div>
    </div>
  </v-app>
</template>

<script setup></script>

<style scoped>
/* .form {
  width: 100%;
} */
.maincontainer {
  margin: 0 0 50px 0;
}
.title {
  font-size: 14px;
}
.login {
  color: rgb(255 255 255);
  font-size: 12px;
}
.resetpassword {
  font-size: 10px;
  text-decoration: underline;
}
.resetpasswordcontainer {
  margin: 8px 0 0 0;
}
.signup {
  color: rgb(255 255 255 100%);
  font-size: 12px;
}
.mailaddress {
  font-size: 12px;
  text-align: left;
  margin-left: 40px;
}
.message {
  font-size: 12px;
}

@keyframes blink {
  0%,
  100% {
    opacity: 0.2;
  }
  50% {
    opacity: 1;
  }
}

.dot {
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
  animation-name: blink;
}

.dot1 {
  animation-delay: 0.2s;
}

.dot2 {
  animation-delay: 0.4s;
}

.dot3 {
  animation-delay: 0.6s;
}

/*スマートフォン-----------------------------------------------------------------------------------*/
/*@media only screen and (max-width:768px){*/
@media only screen and (max-width: 1000px) {
  .login {
    color: rgb(255 255 255);
    font-size: 12px;
  }
}

.home-button {
  color: white;
  font-size: 14px;
  text-transform: none;
}
</style>
